import gql from 'graphql-tag'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { dataFetched, makesQueries } from 'data/graphql'

const getApplications = gql`
  query getApplications {
    getApplications(
      input: { pagination: { first: 50 }, excludeInstalled: false }
    ) {
      nodes {
        __typename
        id
        isInstalled
        name
        photoURL
        name
        clientId
        features
        labels {
          shareToAction
          shareToActionVerb
          shareToSuccess
          shareToSuccessLinkLabel
          userConnectIncentive
        }
        integration {
          id
          unfurlPatterns
        }
      }
    }
  }
`

export default function syncsApplications() {
  return compose(
    connect(
      null,
      { dataFetched }
    ),
    makesQueries({
      query: getApplications,
      getOnResultFromProps: ({ dataFetched }) => ({ result }) => {
        const applications = result.data.getApplications.nodes

        dataFetched(applications)
      },
    })
  )
}
